import '@entur/loader/dist/styles.css'
import './index.scss'

import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { ToastProvider } from '@entur/alert'
import posthog from 'posthog-js'
import Page from './components/layout/page'
import SearchPage from './pages/search-page'
import EmployeePage from './pages/employee-page'
import NewEmployeePage from './pages/new-employee-page'
import ChangeEmployeePage from './pages/change-employee-page'
import { trackingToken } from './utils/tracking-utils'
import ReportsPage from './pages/reports-page'
import { FeatureFlagProvider } from './contexts/feature-flag-context'
import Auth0ProviderWithHistory from './contexts/auth0-provider-history'
import { ClientInfoProvider } from './contexts/client-info-context'
import Login from './components/login/login'

createBrowserHistory()
// Initialize posthog tracking
posthog.init(trackingToken(), { api_host: 'https://eu.posthog.com' })

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Could not find root element')
}
const root = createRoot(rootElement)

root.render(
  <Auth0ProviderWithHistory>
    <Login>
      <ClientInfoProvider>
        <BrowserRouter>
          <ToastProvider>
            <FeatureFlagProvider>
              <Page>
                <Routes>
                  <Route path="/" element={<SearchPage />} />
                  <Route path="/nyansatt" element={<NewEmployeePage />} />
                  <Route path="/ansatt/:id/endre" element={<ChangeEmployeePage />} />
                  <Route path="/ansatt/:id" element={<EmployeePage />} />
                  <Route path="/rapporter" element={<ReportsPage />} />
                </Routes>
              </Page>
            </FeatureFlagProvider>
          </ToastProvider>
        </BrowserRouter>
      </ClientInfoProvider>
    </Login>
  </Auth0ProviderWithHistory>
)
